import React from "react";
import styles from "./style/answer_common.module.css";
import { useLanguage } from '../../functions/setGetLanguage';

const AnswerCommon = ({ choices, FunctionOnClick }) => {
  const { language } = useLanguage();

  return (
    <div className={styles.choices}>
      {choices.map((choice, i) => (
        <button
          key={i}
          className={styles.choiceButton}
          onClick={() => FunctionOnClick(choice)}
        >
          {choice[`text${language}`]}
        </button>
      ))}
    </div>
  );
};

export default AnswerCommon;
